import {FormConfig} from './formConfig.types';
import Console from 'sos-common/js/utils/console.log';

// export let setFormConfig: (formConfig: FormConfig) => void;

// export const formConfigPromise = new Promise<FormConfig>((resolve, reject) => {
//     setFormConfig = resolve;
// });

let _formConfig: FormConfig;

export function setFormConfig(formConfig: FormConfig) {
    _formConfig = formConfig;
}

export function getFormConfig() {
    if(!_formConfig) {
        Console.warn('formConfig Not Set');
    }
    return _formConfig;
}